import React, { ReactNode } from 'react';
import Quote from '@root/src/components/Quote';

type QuoteCalloutProps = {
  image: ReactNode;
  citation: string;
  quote: string;
};

const QuoteCallout = ({ image, citation, quote }: QuoteCalloutProps) => (
  <div
    className="
      row
      relative
      before:absolute
      before:inset-0
      before:left-64
      before:top-64
      before:bg-white
      lg:before:left-100
    "
  >
    <div className="relative col-start-4 col-end-11 row-start-1">{image}</div>
    <div className="relative col-start-1 col-end-12 row-start-2 my-64">
      <div>
        <Quote citationName={citation}>{quote}</Quote>
      </div>
    </div>
  </div>
);

export default QuoteCallout;
